import React, { FC } from "react";
import S from "./index.module.scss";
import clsx from "clsx";

interface ITextareaField {
  id: string;
  label: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error: string;
  onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void;
}

const TextareaField: FC<ITextareaField> = ({
  id,
  label,
  value,
  onChange,
  placeholder = "",
  required = false,
  disabled = false,
  error = "",
}) => {
  return (
    <div className={S.wrapper}>
      <label className={S.label} htmlFor={id}>
        {label}
        {required && "*"}
      </label>
      <textarea
        className={clsx(S.textarea, {
          [S["textarea--error"]]: !!error,
        })}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      {error && (
        <span className={S.error} id={`${id}-error`}>
          {error}
        </span>
      )}
    </div>
  );
};

export default TextareaField;
